"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    NONE: '0px',
    FOUR: '4px',
    EIGHT: '8px',
    TEN: '10px',
    TWELVE: '12px',
    FOURTEEN: '14px',
    SIXTEEN: '16px',
    EIGHTEEN: '18px',
    TWENTY: '20px',
    TWENTY_FOUR: '24px',
    THIRTY_TWO: '32px',
    SIXTY_FOUR: '64px',
};
